import { COLLECTION_URL } from '../utils/constants';
import { makeSDSNetworkCall } from './makeSDSNetworkCall';

/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
export function createSDSCollection(collectionName: string, body: any = {}) {
    return makeSDSNetworkCall(COLLECTION_URL, 'POST', {
        Name: collectionName,
        ...body,
    });
}
